import * as React from "react";
import {
  Container,
  Col,
  Row,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Nav,
  NavItem,
  TabPane,
  NavLink,
  TabContent,
  Card,
  CardBody
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { cs, enGB } from 'date-fns/locale'
import { withTranslation } from 'react-i18next';

import { licenceAction, systemsAction } from "../../_actions";
import { bindActionCreators, compose } from "redux";
import { Loading } from "../Loading";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { LicencePrices, LicenceLanguages } from ".";

// https://availity.github.io/availity-reactstrap-validation/
// react-datepicker
// react-day-picker

const defaultLicence = {
  name: "Effit - testovaci licence",
  identification: 90,
  from: "2019-03-03",
  to: "2019-03-03",
  numberOfMonths: "1"
}

const defaultLanguages1 = [
    {
      description: "Testovaci popis",
      id: "",
      language: "cs",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      name: "Testovaci licence"
    },
    {
      description: "Testovaci popis",
      id: "",
      language: "en",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      name: "Testovaci licence"
    }
  ];
const defaultPrices1 = [
    {
      currency: "CZK",
      id: "",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      priceWithVAT: "110000",
      priceWithoutVAT: "90000"
    },
    {
      currency: "EUR",
      id: "",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      priceWithVAT: "110000",
      priceWithoutVAT: "90000"
    },
    {
      currency: "USD",
      id: "",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      priceWithVAT: "110000",
      priceWithoutVAT: "90000"
    }
];
const defaultLanguages = [
    {
      description: "",
      id: "",
      language: "cs",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      name: ""
    },
    {
      description: "",
      id: "",
      language: "en",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      name: ""
    }
];
const defaultPrices = [
    {
      currency: "CZK",
      id: "",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      priceWithVAT: "",
      priceWithoutVAT: ""
    },
    {
      currency: "EUR",
      id: "",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      priceWithVAT: "",
      priceWithoutVAT: ""
    },
    {
      currency: "USD",
      id: "",
      licenceTypeId: "00000000-0000-0000-0000-000000000000",
      priceWithVAT: "",
      priceWithoutVAT: ""
    }
];

class NewLicence extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const i18nextLng = localStorage.getItem("i18nextLng");
    
    this.state = {
      test: "",
      values: {
        licenceTypeMetas: {},
        prices: {}
      },
      locales: i18nextLng == "cs" ? cs : enGB
    };

    this.handleValidSubmit = this.handleValidSubmit.bind(this);
    this.systemId = this.systemId.bind(this);
  }

  componentDidMount() {
    this.props.loadSystems();
  }

  getDate(datetime: string) {
    let date = {
      year: datetime.slice(0, 4),
      month: datetime.slice(5, 7),
      day: datetime.slice(8, 10)
    };
    return date.year + "-" + date.month + "-" + date.day;
  }

  renderSystems(systems: any) {
    return systems.map((data: any) => {
      return (
        <option key={data.id} value={data.id}>
          {data.name}
        </option>
      );
    });
  }

  getDateFromDate(datetime: any) {
    let date = {
      day: datetime.getDate(),
      month: datetime.getMonth() + 1,
      year: datetime.getFullYear()
    };

    date.month = date.month.toString().length == 1 ? "0" + date.month : date.month;
    date.day = date.day.toString().length == 1 ? "0" + date.day : date.day;
    return date.year + "-" + date.month + "-" + date.day;
  }

  onPriceChange(price: any) {
    this.setState({ price });
  }

  onLanguageChange(languages: any) {
    this.setState({ languages });
  }

  onAvailableFromChange(date: any) {
    this.setState({avaiableFrom: date})
  }
  
  onAvailableToChange(date: any) {
    this.setState({avaiableTo: date})
  }

  handleValidSubmit(event: any, values: any) {
    const { systems } = this.props;
    this.setState({
      systemInfoId: this.state.systemId ? this.state.systemId : systems.data[0].id
      },
    () => {

      this.setState({
      values: {
        id: "00000000-0000-0000-0000-000000000000",
        name: values.name,
        avaiableFrom: this.state.avaiableFrom ? this.state.avaiableFrom : defaultLicence.from,
        avaiableTo: this.state.avaiableTo ? this.state.avaiableTo : defaultLicence.to,
        hasPeriod: values.numberOfMonths != "0",
        numberOfMonths: values.numberOfMonths,
        licenceIdentification: values.licenceIdentification,
        systemInfoId: this.state.systemId ? this.state.systemId : systems.data[0].id,
        systemInfo: {
          id: this.state.systemInfoId,
          name: systems.data.map((system: any)=>{if(system.id == this.state.systemInfoId) return system.name})[0],
          serviceUrl: systems.data.map((system: any)=>{if(system.id == this.state.systemInfoId) return system.serviceUrl})[0],
          token: systems.data.map((system: any)=>{if(system.id == this.state.systemInfoId) return system.token})[0],
        },
        licenceTypeMetas: this.state.languages,
        prices: this.state.price,
      }
    })
    }
    );

    console.log(this.state.values);
    this.props.createLicence(this.state.values);
    window.scrollTo(0, 0);
  }

  systemId(event: any) {
    this.setState({ systemId: event.target.value });
  }

  render() {
    const { systems, t } = this.props;

    return (
      <Container>
        <Breadcrumb>
          <BreadcrumbItem>
            <Link to="/">Sypal</Link>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <Link to="/licence-list">{t("licence_list")}</Link>
          </BreadcrumbItem>
          <BreadcrumbItem active>{t("new_licence")}</BreadcrumbItem>
        </Breadcrumb>
        <AvForm
          className="sypal-form"
          style={{ paddingBottom: "30px" }}
          onValidSubmit={this.handleValidSubmit}
          id="licence-form"
        >
          <AvField name="name" label={t("name")}
          value={defaultLicence.name} required />
          <AvField
            name="licenceIdentification"
            label={t("id")}
            value={defaultLicence.identification}
          />

          <AvField
            type="select"
            name="systemInfoId"
            label={t("system")}
            onChange={this.systemId}
          >
            {this.renderSystems(systems.data)}
          </AvField>
            <Row className="form-group">
              <Col md="6" className="mb-3 mb-sm-3 mb-md-0 mb-lg-0 mb-xl-0">
                <Row className="sypal-input m-0">
                  <span>{t("available_from")}</span>
                </Row>
                <DatePicker
                  selected={this.state.avaiableFrom ? new Date(this.state.avaiableFrom) : new Date(defaultLicence.from)}
                  onChange={date => this.onAvailableFromChange(this.getDateFromDate(date))}
                  dateFormat="PP"
                  label="Available from"
                  locale={this.state.locales}
                  className="w-100 is-untouched is-pristine av-valid form-control"
                />
              </Col>
              <Col md="6">
                <Row className="sypal-input m-0">
                  <span>{t("available_to")}</span>
                </Row>
                <DatePicker
                  selected={this.state.avaiableTo ? new Date(this.state.avaiableTo) : new Date(defaultLicence.to)}
                  onChange={date => this.onAvailableToChange(this.getDateFromDate(date))}
                  dateFormat="PP"
                  label="Available to"
                  locale={this.state.locales}
                  className="w-100 is-untouched is-pristine av-valid form-control"
                />
                </Col>
            </Row>
            <AvField type="select" name="numberOfMonths" label={t("duration")} value={defaultLicence.numberOfMonths}>
              <option value="1">1 {t("mesic")}</option>
              <option value="3">3 {t("mesice")}</option>
              <option value="6">6 {t("mesicu")}</option>
              <option value="12">1 {t("year")}</option>
              <option value="0">{t("lifespan")}</option>
          </AvField>
        </AvForm>
        <LicenceLanguages
          languages={defaultLanguages1}
          onLanguageChange={(languages: any) =>
            this.onLanguageChange(languages)
          }
        />
        <LicencePrices
          prices={defaultPrices1}
          onPriceChange={(prices: any) => this.onPriceChange(prices)}
        />
          <Row style={{ justifyContent: "center", padding: "30px 0" }}>
            <Col style={{ textAlign: "center" }} sm="12" md="4">
              <Button color="success" type="submit" form="licence-form" className="w-100">
                {t("save")}
              </Button>
            </Col>
          </Row>
      </Container>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    licence: state.licence,
    systems: state.systems
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      load: licenceAction.loadLicence,
      loadSystems: systemsAction.loadSystems,
      createLicence: licenceAction.createLicence
    },
    dispatch
  );
};

const NewLicenceComponent = compose(
  withTranslation('licences'),
  connect(mapStateToProps,mapDispatchToProps)
)(NewLicence);

export { NewLicenceComponent as NewLicence };
